<template>
  <v-dialog
    :value="dialog"
    @input="setDialogAction(!dialog)"
    width="750px"
    content-class="rounded-xl"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        Показатель
      </v-card-title>
      <v-card-subtitle>
        {{titleDialog}}
      </v-card-subtitle>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-select
            outlined
            :items="listContracts"
            v-model="eff_contract_id"
            :readonly="isEditDialog"
            item-text="indicator_name"
            item-value="id"
            class="rounded-xl"
            label="Название"
            no-data-text="Эффективные контракты отсутствуют"
            :rules="contractNameRules"
            :color="colorElem"
          >
          </v-select>

          <v-card v-if="isSelectAnswerContract" flat outlined rounded="xl" class="mb-5">
            <v-card-text>
              <div class="text-subtitle-1">{{ planDescriptionContract }}</div>
              <v-radio-group
                v-model="fact"
                row
              >
                <v-radio
                  label="Да"
                  value="Да"
                  :color="colorElem"
                ></v-radio>
                <v-radio
                  label="Нет"
                  value="Нет"
                  :color="colorElem"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
          <div v-else>
            <v-text-field
              v-if="!isContractPublication"
              outlined
              :disabled="isEffConIdEmpty && !isEditDialog"
              v-model="fact"
              class="rounded-xl"
              :suffix="unitsMeasurementContract"
              :placeholder="planDescriptionContract"
              label="Факт"
              :rules="factRules"
              :color="colorElem"
              type="number"
              min="0"
            >
            </v-text-field>

            <v-text-field
              v-else
              outlined
              :disabled="isEffConIdEmpty && !isEditDialog"
              v-model="author"
              :placeholder="planDescriptionContract"
              class="rounded-xl"
              label="Авторы"
              :rules="authorRules"
              :color="colorElem"
              hint="Укажите количество авторов в публикации"
              type="number"
              min="0"
            >
            </v-text-field>
          </div>
          <div v-if="isFilePresent">
            <v-chip
              :href="file.link"
              close
              @click:close="file = null; link_source = null"
              target="_blank"
              class="rounded-xl"
            >
              <v-icon small class="mr-4">fa fa-file</v-icon>
              <div class="text-truncate" style="max-width: 335px">{{ file.filename }}</div>
            </v-chip>
          </div>
          <div v-else class="d-flex flex-column">
            <v-expand-transition>
              <v-btn-toggle
                v-model="toggle_exclusive"
                mandatory
                rounded
                v-show="isContractPublication"
                class="align-self-center mb-2"
              >
                <v-btn small>
                  Файл
                </v-btn>
                <v-btn small>
                  Ссылка
                </v-btn>
              </v-btn-toggle>
            </v-expand-transition>

            <v-file-input
              outlined
              v-if="toggle_exclusive === 0"
              :disabled="isEffConIdEmpty && !isEditDialog"
              v-model="file"
              class="rounded-xl"
              label="Подтверждающий документ"
              :rules="fileInputRules"
              :color="colorElem"
              accept=".pdf"
            >
            </v-file-input>

            <v-text-field
              v-model="link_source"
              v-if="toggle_exclusive === 1"
              outlined
              placeholder="Добавьте ссылку"
              label="Ссылка на подтверждающий документ"
              class="rounded-xl"
              suffix="https/"
              :rules="linkSourcesRules"
              :color="colorElem"
            >
            </v-text-field>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex flex-row justify-center">
          <v-btn
            elevation="0"
            :color="colorElem"
            outlined
            class="rounded-xl"
            @click="closeDialog"
          >
            Отмена
          </v-btn>
          <v-btn
            elevation="0"
            class="white--text rounded-xl"
            :color="colorElem"
            :loading="loadingSentData"
            @click="sendDataServe"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import _ from "lodash";
import CheckContractServices from "../services/CheckContract.services";
import useIsValidURL from "../app/utils/useIsValidURL";

const {mapFields} = createHelpers({
  getterType: 'effective_contract/getPayloadPersonContract',
  mutationType: 'effective_contract/updatePayloadPersonContract',
});

export default {
  name: "PersonEffConDialog",

  props: {},

  data() {
    return {
      colorElem: "teal darken-3",
      contractNameRules: [
        v => !!v || 'Обязательное поле.',
      ],
      fileInputRules: [
        v => !!v || 'Обязательное поле.',
        v => {
          if (!v) return true;
          const allowedFormats = ['application/pdf'];
          return allowedFormats.includes(v.type) || 'Доступны только PDF файлы.';
        }
      ],
      factRules: [
        v => !!v || 'Обязательное поле.',
        v => /^\d+(\.\d+)?$/.test(v) && v > 0 || 'Только положительные числа'
      ],
      authorRules: [
        v => !!v || 'Обязательное поле.',
        v => /^\d+$/.test(v) && v > 0 || 'Только положительные числа'
      ],
      linkSourcesRules: [
        v => !!v || 'Обязательное поле.',
        v => useIsValidURL(v) || 'Неправильная ссылка'
      ],
      valid: true,
      toggle_exclusive: 0,
      loadingSentData: false,
    };
  },

  watch: {
    eff_contract_id: function () {
      if (!this.isEditDialog) {
        this.fact = null;
        this.author = null;
        this.file = null;
        this.link_source = null;
      }
    },

    author: function () {
      if (this.eff_contract_id !== null) this.setFactWithOutAuthor(this.author);
    },

    dialog: function () {
      if (!this.dialog) this.toggle_exclusive = 0;
    }
  },

  computed: {
    ...mapFields([
      'fact',
      'author',
      'eff_contract_id',
      'file',
      'link_source',
    ]),

    ...mapState({
      dialog: state => state.effective_contract.dialogContract,
      typeDialogContract: state => state.effective_contract.typeDialogContract,
      isEditDialog: state => state.effective_contract.isEditDialog,
    }),

    ...mapGetters({
      listBasicBidContract: "effective_contract/listBasicBidContract",
      listStimulatingBidContract: "effective_contract/listStimulatingBidContract",
      listBasicDeanContract: "effective_contract/listBasicDeanContract",
      listStimulatingDeanContract: "effective_contract/listStimulatingDeanContract",
      listBasicHeadDepartmentContract: "effective_contract/listBasicHeadDepartmentContract",
      listStimulatingHeadDepartmentContract: "effective_contract/listStimulatingHeadDepartmentContract",

      listPersonBasicBidContract: "effective_contract/listPersonBasicBidContract",
      listPersonStimulatingBidContract: "effective_contract/listPersonStimulatingBidContract",
      listPersonBasicDeanContract: "effective_contract/listPersonBasicDeanContract",
      listPersonStimulatingDeanContract: "effective_contract/listPersonStimulatingDeanContract",
      listPersonBasicHeadDepartmentContract: "effective_contract/listPersonBasicHeadDepartmentContract",
      listPersonStimulatingHeadDepartmentContract: "effective_contract/listPersonStimulatingHeadDepartmentContract",

    }),

    isEffConIdEmpty() {
      return this.eff_contract_id === null;
    },

    isContractPublication() {
      const contract = _.find(this.listContracts, {'id': this.eff_contract_id});
      if (contract === null || contract === undefined) return false;
      return contract.is_publication;
    },

    isSelectAnswerContract() {
      const contract = _.find(this.listContracts, {'id': this.eff_contract_id});
      if (contract === null || contract === undefined) return false;
      return contract.indicator_name === "Обеспечение соотношения численности числа ППС и обучающихся очной формы обучения";
    },

    unitsMeasurementContract() {
      if (this.eff_contract_id === null) return "";
      return _.find(this.listContracts, {'id': this.eff_contract_id})?.units_measurement || "";
    },

    planDescriptionContract() {
      if (this.eff_contract_id === null) return ""
      return _.find(this.listContracts, {'id': this.eff_contract_id})?.plan_description || ""
    },

    currentList() {
      let currentList = [];

      switch (this.typeDialogContract) {
        case "bidBasic":
          currentList = this.listBasicBidContract;
          break;
        case "bidStimulating":
          currentList = this.listStimulatingBidContract;
          break;
        case "deanBasic":
          currentList = this.listBasicDeanContract;
          break;
        case "deanStimulating":
          currentList = this.listStimulatingDeanContract;
          break;
        case "headDepartmentBasic":
          currentList = this.listBasicHeadDepartmentContract;
          break;
        case "headDepartmentStimulating":
          currentList = this.listStimulatingHeadDepartmentContract;
          break;
        default :
          currentList = null
          break;
      }

      if (_.isNull(currentList)) return currentList
      return _.filter(currentList, {"is_auto": false})
    },

    currentPersonContractList() {
      switch (this.typeDialogContract) {
        case "bidBasic":
          return this.listPersonBasicBidContract;
        case "bidStimulating":
          return this.listPersonStimulatingBidContract;
        case "deanBasic":
          return this.listPersonBasicDeanContract;
        case "deanStimulating":
          return this.listPersonStimulatingDeanContract;
        case "headDepartmentBasic":
          return this.listPersonBasicHeadDepartmentContract;
        case "headDepartmentStimulating":
          return this.listPersonStimulatingHeadDepartmentContract;
        default :
          return null
      }
    },

    listContracts() {
      if (this.currentPersonContractList === null) return []
      if (this.isEditDialog) return this.currentList;
      return CheckContractServices.listContracts(this.currentPersonContractList, this.currentList)
    },

    isFilePresent() {
      return this.file?.link !== undefined && this.file !== null
    },

    titleDialog() {
      const flagBasic = this.typeDialogContract === "bidBasic" ||
        this.typeDialogContract === "headDepartmentBasic" ||
        this.typeDialogContract === "deanBasic";

      if (flagBasic) return "Базовая часть"
      else return "Стимулирующая часть"
    },

  },

  methods: {
    ...mapActions({
      sendPersonEffContract: 'effective_contract/sendPersonEffContract',
      setDialogAction: 'effective_contract/setDialogAction',
    }),

    ...mapMutations({
      setFactWithOutAuthor: "effective_contract/setFactWithOutAuthor",
    }),

    async sendDataServe() {
      if (this.$refs.form.validate()) {
        this.loadingSentData = true;
        await this.sendPersonEffContract();
        this.setDialogAction(false);
        this.loadingSentData = false;
        this.$refs.form.resetValidation()
      }
    },

    closeDialog() {
      this.setDialogAction(false);
      this.$refs.form.resetValidation();
    }
  },


}
</script>

<style scoped>

</style>